/* eslint-disable @typescript-eslint/no-explicit-any */
import "reflect-metadata";
const SERVICE_KEY = "__service__";
export const defaultData = {
    singleton: true,
};
export function setServiceData(object, data) {
    Reflect.defineMetadata(SERVICE_KEY, data, object);
}
export function getServiceData(object) {
    const metadata = Reflect.getMetadata(SERVICE_KEY, object);
    return metadata || { ...defaultData };
}
